import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const getAvailable = async () =>
  request(url(constants.api.publicCall.available), {
    method: 'GET',
    headers: headers(),
  })

const getInfo = async () =>
  request(url(constants.api.publicCall.info), {
    method: 'GET',
    headers: headers(),
  })

const getAllPublicCallDegrees = async () =>
  request(url(constants.api.publicCall.degrees), {
    method: 'GET',
    headers: headers(),
  })

const getCitiesByDegree = async ref =>
  request(url(constants.api.publicCall.cities(ref)), {
    method: 'GET',
    headers: headers(),
  })

const getSchoolsByDegreeAndCity = async (
  degree,
  city,
  exceptOfferIds,
  zipcode,
  weakStreetId
) =>
  request(
    url(
      constants.api.publicCall.schools(
        degree,
        city,
        exceptOfferIds,
        zipcode,
        weakStreetId
      )
    ),
    {
      method: 'GET',
      headers: headers(),
    }
  )

const getShiftsByDegreeAndSchool = async (degree, school, exceptOfferIds) =>
  request(url(constants.api.publicCall.shifts(degree, school, exceptOfferIds)), {
    method: 'GET',
    headers: headers(),
  })

const getCurriculumsByDegreeAndSchoolAndShift = async (
  degree,
  school,
  shift,
  exceptOfferIds
) =>
  request(
    url(
      constants.api.publicCall.curriculums(
        degree,
        school,
        shift,
        exceptOfferIds
      )
    ),
    {
      method: 'GET',
      headers: headers(),
    }
  )

const getOtherCurriculumsByDegreeAndCity = async (
  degree,
  city,
  exceptOfferIds
) =>
  request(
    url(
      constants.api.publicCall.otherCurriculums(degree, city, exceptOfferIds)
    ),
    {
      method: 'GET',
      headers: headers(),
    }
  )

const getSchoolsQuestions = async () =>
  request(url(constants.api.publicCall.schoolsQuestions), {
    method: 'GET',
    headers: headers(),
  })

const getQuizQuestions = async () =>
  request(url(constants.api.publicCall.quizQuestions), {
    method: 'GET',
    headers: headers(),
  })

const getQuestions = async () =>
  request(url(constants.api.publicCall.questions), {
    method: 'GET',
    headers: headers(),
  })

const getAllOffersCities = async () =>
  request(url(constants.api.offers.cities), {
    method: 'GET',
    headers: headers(),
  })

const getOffersSchools = async cityRef =>
  request(url(constants.api.offers.schools(cityRef)), {
    method: 'GET',
    headers: headers(),
  })

const getOffers = async (schoolRef, cityRef) =>
  request(url(constants.api.offers.index(schoolRef, cityRef)), {
    method: 'GET',
    headers: headers(),
  })

const getWaitingList = async offerId =>
  request(url(constants.api.offers.waitingList(offerId)), {
    method: 'GET',
    headers: headers(),
  })

const insertWaitingList = async (offerId, user_login) =>
  request(url(constants.api.waitingList.insert(offerId, user_login)), {
    method: 'POST',
    headers: headers(),
  })

const getSchoolInfo = async schoolId =>
  request(url(constants.api.waitingList.schoolInfo(schoolId)), {
    method: 'GET',
    headers: headers(),
  })

const validateUser = async (user, password, offerId) => {
  const body = JSON.stringify({
    user,
    password,
    offer_id: offerId,
  })

  return request(url(constants.api.waitingList.login), {
    method: 'POST',
    headers: headers(),
    body
  })
}

const publicCallApi = {
  getAvailable,
  getInfo,
  getAllPublicCallDegrees,
  getCitiesByDegree,
  getSchoolsByDegreeAndCity,
  getShiftsByDegreeAndSchool,
  getCurriculumsByDegreeAndSchoolAndShift,
  getOtherCurriculumsByDegreeAndCity,
  getSchoolsQuestions,
  getQuizQuestions,
  getQuestions,
  getAllOffersCities,
  getOffersSchools,
  getOffers,
  getWaitingList,
  insertWaitingList,
  getSchoolInfo,
  validateUser
}

export default publicCallApi
